<footer
  [class.hide-footer]="shouldHideFooter()"
  class="footer my-auto flex flex-col py-5"
  aria-label="footer">
  <div class="footer-content-container flex flex-col justify-between">
    <ng-container *ifLoggedIn>
      <ng-container
        *ngIf="(selectedScheme$ | async) === BnzRewardsProgramSchemes.Bnz"
        [ngTemplateOutlet]="footerContent">
      </ng-container>
    </ng-container>

    <ng-container
      *ifNotLoggedIn
      [ngTemplateOutlet]="footerContent"></ng-container>

    <ng-template #footerContent>
      <div class="links-container flex flex-row flex-wrap items-center">
        <div class="link-wrapper mr-4 mt-0 lg:mt-0">
          <a class="link-item focus-link" [routerLink]="faqsUrl">
            {{ 'wl.bnz.footer.faqs' | translate }}
          </a>
        </div>

        <div class="link-wrapper mr-4 mt-3 lg:ml-4 lg:mt-0">
          <a
            class="link-item focus-link"
            [href]="rewardProgrammeTnCUrl"
            target="_blank"
            rel="noopener">
            <ng-container
              *ngIf="!isBankwideEnabled; else bankwideTermsAndConditionsTitle">
              {{ 'wl.bnz.footer.bnz_terms_and_conditions' | translate }}
            </ng-container>
            <ng-template #bankwideTermsAndConditionsTitle>
              {{ 'wl.bnz.footer.bnz_terms_and_conditions_update' | translate }}
            </ng-template>
          </a>
        </div>

        <div class="link-wrapper mr-4 mt-3 lg:ml-4 lg:mt-0">
          <a class="link-item focus-link" [routerLink]="tncsUrl">
            <ng-container
              *ngIf="!isBankwideEnabled; else bankwideTermsOfUseTitle">
              {{ 'wl.bnz.footer.terms_of_use' | translate }}
            </ng-container>
            <ng-template #bankwideTermsOfUseTitle>
              {{ 'wl.bnz.footer.terms_of_use_update' | translate }}
            </ng-template>
          </a>
        </div>

        <div class="link-wrapper mr-4 mt-3 lg:ml-4 lg:mt-0">
          <a class="link-item focus-link" [routerLink]="privacyPolicyUrl">
            {{ 'wl.bnz.footer.privacy_policy' | translate }}
          </a>
        </div>

        <div class="link-wrapper mt-3 lg:ml-4 lg:mt-0" *ifLoggedIn>
          <a
            class="link-item contact-us-link focus-link"
            [routerLink]="contactUsUrl">
            {{ 'wl.bnz.footer.contact_us' | translate }}
          </a>
        </div>
      </div>
    </ng-template>

    <div
      class="copyright-section mt-8 flex flex-col items-baseline whitespace-nowrap lg:ml-auto lg:mt-0 lg:flex-row">
      <span
        [attr.aria-hidden]="true"
        [innerHTML]="'wl.bnz.footer.copyright' | translate: getCurrentYear()">
      </span>
      <span class="sr-only">Powered by Ascenda</span>
      <span
        class="powered-by-text mt-5 flex items-center lg:ml-4 lg:mt-0 lg:pl-4"
        aria-hidden="true">
        Powered by
        <img
          [src]="ascendaImageUrl"
          alt=""
          class="h-[24px] w-[94px]"
          aria-hidden="true" />
      </span>
    </div>
  </div>
</footer>
